import OrderItemsStore from './order_items_store'
import Currency from 'utils/currency'

const currency = Currency.getCurrency()

function checkout (shippingAddress) {
  return new Promise((resolve, reject) => {
    const items = OrderItemsStore.getItems()

    const listingItems = items.map((item) => ({
      listing_id: item.listing_id,
      quantity: item.quantity,
      currency: currency
    }))
    const successUrl = $('[data-checkout-success-url]').data('checkout-success-url')
    const cancelUrl = $('[data-checkout-cancel-url]').data('checkout-cancel-url')

    const checkoutParams = {
      currency: currency,
      newsletter_subscription: $('#receive_newsletters').is(':checked'),
      listing_items: listingItems,
      success_url: successUrl,
      cancel_url: cancelUrl,
      ...(shippingAddress && { shipping_address: shippingAddress })
    }

    $.post('/api/checkouts', { checkout: checkoutParams })
      .then((response) => {
        if (response.url) {
          window.location.href = response.url
        } else {
          reject(new Error(I18n.t('checkout_error')))
        }
      })
      .fail((error) => {
        reject(error)
      })
  })
}

export {
  checkout
}
